var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "755px",
    height: "631px",
    viewBox: "0 0 755 631",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphical elements / illustration / pie") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphical-elements-/-illustration-/-pie",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9E616A",
    fillRule: "nonzero",
    points: "693.560367 618.847918 682.312857 618.847001 676.962492 575.465189 693.562202 575.465189"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9E616A",
    fillRule: "nonzero",
    points: "650.441853 618.847918 639.194343 618.847001 633.843978 575.465189 650.443688 575.465189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.5219,628.072528 L164.5219,279.629066 C164.5219,275.160198 168.144634,271.537464 172.613502,271.537464 L208.722964,271.537464 C213.191832,271.537464 216.814566,275.160198 216.814566,279.629066 L216.814566,279.629066 L216.814566,628.980769 L164.5219,628.072528 Z",
    id: "ae5c11dc-7e77-468a-a39f-cc8da6ee1565-162",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.785874,629.164252 L283.785874,352.104866 C283.785874,347.635998 287.408608,344.013264 291.877476,344.013264 L327.986938,344.013264 C332.455806,344.013264 336.07854,347.635998 336.07854,352.104866 L336.07854,352.104866 L336.07854,628.567932 L283.785874,629.164252 Z",
    id: "bc696f83-47b6-45c9-967f-bb64f1f3bee5-163",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.862049,299.994622 C70.7762598,299.994622 69.7921015,299.355757 69.3495534,298.364248 C68.9070052,297.37274 69.0887994,296.213705 69.8136627,295.405305 L190.550519,160.737012 L309.372584,227.460142 L428.901499,21.5026707 L550.667989,121.725803 C551.428111,122.350408 551.797033,123.333244 551.635659,124.303747 C551.474284,125.274249 550.807156,126.084812 549.885807,126.429823 C548.964458,126.774834 547.929017,126.60182 547.169885,125.976013 L430.408426,29.8722953 L311.40942,234.916828 L191.703206,167.697349 L73.9121049,299.079452 C73.3904915,299.662847 72.6446278,299.994622 71.862049,299.994622 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a1f8771a-4bf9-4603-9747-6ae739e4ad47",
    fill: "#C9B181",
    fillRule: "nonzero",
    cx: 71.4042496,
    cy: 297.24252,
    r: 25.6876252
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ffdbdf53-78c2-412f-9ede-372406e5d245",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    cx: 190.668224,
    cy: 164.217318,
    r: 25.6876252
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b7cff929-f00d-4f86-944c-e500b6ceb6ad",
    fill: "#E6E6E6",
    fillRule: "nonzero",
    cx: 309.932198,
    cy: 231.188627,
    r: 25.6876252
  }), /*#__PURE__*/React.createElement("circle", {
    id: "eabc0b76-6faa-4fa0-934c-daff28b491dd",
    fill: "#C9B181",
    fillRule: "nonzero",
    cx: 429.196172,
    cy: 25.6876252,
    r: 25.6876252
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a7ca0488-8ee6-49e2-b245-2872b84c042e",
    fill: "#C9B181",
    fillRule: "nonzero",
    cx: 658.549969,
    cy: 217.000801,
    r: 25.6876252
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.467568,417.108319 C659.081905,418.266427 683.667888,409.495553 685.000397,422.83887 C697.655039,460.090514 697.279523,602.887399 697.279523,602.887399 L678.013804,603.804814 C678.013804,603.804814 662.618714,490.34405 655.339144,466.070657 C651.686116,495.573812 652.32616,608.39189 652.32616,608.39189 L634.895271,609.309305 C634.895271,609.309305 619.259609,513.239972 619.170362,485.042592 C617.270157,464.388356 621.930644,433.781166 619.936065,413.81467 C629.469213,416.836078 639.503094,417.95511 649.467659,417.108191 L649.467568,417.108319 Z",
    id: "b579ef19-595a-43de-9b6d-0ead8268ca48-164",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.313823,627.929411 L522.313823,226.327244 C522.313823,221.176875 525.936695,217.000801 530.405425,217.000801 L566.514887,217.000801 C570.983616,217.000801 574.606488,221.175958 574.606488,226.327244 L574.606488,628.980769 L522.313823,627.929411 Z",
    id: "b3465432-03e0-48eb-8016-b04aa244e72c-165",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.761716,309.03681 C612.90566,301.153629 608.195553,293.717751 602.71609,286.862885 C601.571175,285.524099 600.528501,284.101156 599.596878,282.606078 C597.624436,279.18412 597.03729,275.165841 595.789605,271.422787 C592.303427,260.927558 583.606331,252.496512 581.487102,241.64349 C580.716474,237.698605 574.206798,249.164378 575.918392,254.056118 C578.973385,262.909174 579.367873,272.285158 583.257714,280.835467 C587.147554,289.385777 591.716282,297.587468 595.074021,306.330435 C596.982245,311.293651 598.505154,316.422002 601.30327,321.009078 C604.101387,325.596154 608.468283,329.440124 613.74342,330.128185 C613.707716,326.802728 614.212804,323.493578 615.238926,320.330191 C616.385576,316.715575 618.422238,312.458769 616.761716,309.03681 Z",
    id: "ac7870c5-efcc-4c4b-b17f-07e0bff4d096-166",
    fill: "#9E616A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.476306,314.98166 C674.2405,308.494748 675.252698,302.02291 677.457905,295.917773 C678.301927,293.578364 679.292735,291.202259 679.210168,288.716064 C679.090904,286.404177 677.990006,284.284948 676.990023,282.193242 C673.540542,274.991532 671.118566,267.358638 668.733287,259.744092 L664.146211,245.386544 C662.650659,244.289839 671.384617,243.909506 673.246969,246.487443 C679.338606,254.946011 683.953205,264.661437 688.778854,273.899808 C690.009722,276.101209 691.059052,278.399302 691.916414,280.771248 C693.094978,284.615301 693.652439,288.622827 693.567762,292.642601 C693.567762,300.156231 692.576999,307.642339 691.549494,315.09175 C690.898129,319.761394 690.044933,324.843874 686.512885,327.935563 C682.843068,323.238397 679.155123,318.651321 674.476306,314.98166 Z",
    id: "be4b35b3-6955-40b7-9549-45fdba6a2930-167",
    fill: "#9E616A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a7d383a2-21d6-4551-be8a-8c82a5e576cb",
    fill: "#9E616A",
    fillRule: "nonzero",
    cx: 650.219821,
    cy: 288.512407,
    r: 19.0363651
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.74476,269.520068 C634.308683,268.341572 634.578746,267.017728 635.441592,266.10421 C635.916942,265.729621 636.548215,265.589889 637.057803,265.232418 C637.782263,264.623384 638.375181,263.873266 638.800451,263.027741 C641.485623,259.270021 646.491074,257.999476 650.643364,260.021628 C653.789263,261.668242 655.688753,264.965295 658.486667,267.185182 C659.907037,268.33552 661.554577,269.189267 662.983479,270.339604 C665.845741,272.812083 667.880535,276.103187 668.813203,279.768678 C669.741051,283.409381 670.282778,287.137702 670.429413,290.891916 C670.578342,292.018353 670.534287,293.16193 670.29914,294.273572 C670.009665,295.205879 669.577695,296.08779 669.018557,296.888013 C666.142662,301.245093 662.352205,305.201904 657.602518,307.450306 C652.85283,309.698707 647.075389,310.064746 642.391269,307.711769 C641.91966,307.521096 641.51392,307.19698 641.223776,306.779143 C640.957562,306.142958 640.893815,305.440202 641.04121,304.766499 C641.295309,302.103097 640.768419,299.423332 639.52487,297.054395 C638.653077,295.311756 637.345862,293.812498 636.648966,292.009015 C636.000632,289.989996 635.72299,287.870322 635.829457,285.752436 C635.746752,280.264918 636.119461,274.801224 634.74476,269.520068 Z",
    id: "fb091cb1-8ad4-4d57-b74d-c940c723d6bf-168",
    fill: "#2D293D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2570086,628.475273 L45.2570086,434.587831 C45.2570086,432.101635 48.8798811,430.085157 53.3486105,430.085157 L89.4580722,430.085157 C93.9268016,430.085157 97.5496742,432.10347 97.5496742,434.587831 L97.5496742,628.980769 L45.2570086,628.475273 Z",
    id: "ef6ae9ea-be37-4bc6-b1be-067860dc7e9d-169",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.048931,627.792717 L403.048931,172.048374 C403.048931,166.203522 406.671804,161.465073 411.140533,161.465073 L447.249995,161.465073 C451.718724,161.465073 455.341597,166.203522 455.341597,172.048374 L455.341597,628.980769 L403.048931,627.792717 Z",
    id: "b32730d1-ac43-40b1-a176-73e18bf362e5-171",
    fill: "#C9B181",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A0616A",
    fillRule: "nonzero",
    cx: 575.386677,
    cy: 243.450404,
    r: 8.25673668
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A0616A",
    fillRule: "nonzero",
    cx: 667.128195,
    cy: 239.780743,
    r: 8.25673668
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.191744,341.990364 C687.997391,341.253138 694.565561,302.840799 694.527425,301.975181 C694.425792,297.242741 679.986228,291.837743 677.09637,293.718444 C674.369931,295.492799 669.622491,315.850306 666.567196,319.557709 L663.335142,313.901578 L637.647517,313.901578 L636.09059,316.793032 C632.720007,314.762444 629.687885,312.890266 628.606464,312.27079 C628.234791,312.018983 627.830036,311.819863 627.403732,311.679103 C624.733717,311.082035 622.227941,309.904321 620.064411,308.229622 C617.954356,306.605797 608.161756,289.599268 605.537967,290.048793 C602.574716,290.544197 592.579753,299.186248 592.69318,307.479681 C593.952408,307.45281 610.321131,340.183377 610.550825,341.403273 C611.807683,346.559146 615.957996,421.750449 617.297441,425.255021 C623.467975,424.658701 618.596501,423.594499 624.568874,425.255021 C630.999954,427.04398 637.788827,425.108234 644.421738,424.392651 C647.183589,424.119152 649.958312,423.996648 652.73352,424.025685 C662.825087,424.071555 677.228505,424.631179 686.998977,427.135722 C687.054077,420.732164 681.430322,406.879195 679.347734,400.833429 C679.074874,399.026466 679.084158,397.188097 679.375257,395.383982 C679.641436,393.17303 685.013333,344.435073 687.191744,341.990364 Z",
    id: "Path",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.499eefe944a77533c7f95e7fc07aea8e.svg";
export { ForwardRef as ReactComponent };